import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Typography, Divider, Button, Paper, Grid, Box, Fab, CircularProgress, Backdrop } from '@material-ui/core'
import { ArrowBackIosRounded } from '@material-ui/icons'
import axios from 'axios'
import { makeStyles } from '@material-ui/core/styles';

// Components
import CreateCashAdvances1stPage from './components/CreateCashAdvances1stPage'
import CreateCashAdvances2ndPage from './components/CreateCashAdvances2ndPage'
import SideNav from 'components/sidenav/Sidenav'

// StandardComponents
import CreationValidator from 'StandardComponents/CreationValidator/CreationValidator'
import SubmissionValidator from 'StandardComponents/SubmissionValidator/SubmissionValidator'

// Helpers
import onChangeAutoComplete from './commons/onChange'
import onClickAutoComplete from './commons/onClick'

// Services
import TransactionServices from 'Services/Api/NonPOItem/nonPOItem'
import AuthServices from 'Services/Api/Auth/Auth'
import WTaxRateServices from 'Services/Api/MasterData/wTaxRate'
import GLAccountByTypesServices from 'Services/Api/GLAccounts/glAccounts'
import ProjectsServices from 'Services/Api/MasterData/project'

// Validators
import CreateNonPOItemsFirstPageValidator from './CreateCashAdvancesFirstPageValidator'

// Styles
import classes from './CreateCashAdvances.module.scss'

const params = {
  order: true,
  orderBy: '_id',
  sort: 1,
  limit: 50,
  search: toString()
}

const _allowedFieldsFirstPage = {
  dueDate: '',
  vendor: '',
  department: '',
  particulars: '',
  project: '',
  amount: 0,
  releasingCenter: '',
  selectedFile: '',
  requestingGrossPrice: 0.0,
  requestingAmount: 0.0,
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  circular: {
    color: 'red'
  },
  label: {
    marginLeft: '1px',
    color: 'white'
  }
}))

export default function CreateCashAdvances(props) {
  const id = props.match.params.id
  const status = props.match.params.status
  const type = props.match.params.type
  const history = useHistory()
  const classes2 = useStyles()
  const [value, setValue] = React.useState({
    _id: '',
    dueDate: '',
    vendor: '',
    department: '',
    particulars: '',
    poNumber: '',
    rejectionMessage: {},
    crfNumber: '',
    departmentApprover: {},
    accountingApprover: {},
    project: '',
    amount: 0,
    requestType: '',
    CAStatus: '',
    status: '',
    subProject: '',
    releasingCenter: 'BDO Examiner',
    file: null,
    selectedFile: '',
    projectClass: [
      {
        glCategory: 'Advances',
        glAccount: '1080-04-03 Advances to Emp. - For Liquidation AV001006',
        description1: 'Advances to Employee',
        description2: '',
        itemNumber: '',
        projectClass: 'Advances to Employee',
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: '1OV',
        vatType: 'None IVAT-X1',
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: 'X1 (None)',
        wTaxRate: 0,
        wTaxTypeValue: 0,
        wTaxTypeString: '',
        unitPrice: 0,
        subNetPrice: 0,
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0,
        classDepartment: ''
      }
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0
  })
  const [suggestionsVendor, setSuggestionsVendors] = React.useState([])
  const [suggestionsRequestingDepartment, setSuggestionsRequestingDepartment] = React.useState([])
  const [suggestionsProjects, setSuggestionsProject] = React.useState([])
  const [suggestionReleasingCenter, setSuggestionsReleasingCenter] = React.useState(['STP', 'BDO Examiner', 'GIL PUYAT COR PASEO', 'BDO FiveEcom'])
  const [selectedFile, setSelectedFile] = React.useState({})
  const [selectedDate, setSelectedDate] = React.useState(new Date())
  const [next, setNext] = React.useState(false)
  const [fileError, setFileError] = React.useState([''])
  const [submitDisable, setSubmitDisable] = React.useState(false)
  const [errorCollection, setErrorCollection] = React.useState([])
  const [openDialog, setOpenDialog] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [disabled, setDisabled] = React.useState(false)
  const [buttonColor, setButtonColor] = React.useState('red')

  React.useEffect(() => {
    if (id != 'new-transaction') {
      let _params = {
        sort: 1,
        ...params
      }
      TransactionServices.getById(id).then(response => {
        const data = response.data.data
        const projectClass = [...data.projectClasses]
        projectClass.map((item, index) => {
          projectClass[parseInt(index)]['subTotalGrossPrice'] = item.apv.subTotalGrossPrice ? item.apv.subTotalGrossPrice : 0
          projectClass[parseInt(index)]['subTotalNetPrice'] = item.apv.subTotalNetPrice ? item.apv.subTotalNetPrice : 0
          projectClass[parseInt(index)]['glCategory'] = item.glAccount ? item.glAccount.accountType : ''
          projectClass[parseInt(index)]['glAccount'] = item.glAccount ? item.glAccount.accountCode + ' ' + item.glAccount.accountName : ''
          projectClass[parseInt(index)]['wTaxType'] = item.wTaxCode === 'X1' ? 'X1 (None)' : item.wTaxCode + ' ' + item.wTaxType
        })
        _params.search = data.vendor ? data.vendor.bpName : ''
        TransactionServices.getVendorMapping(_params).then(res => {
          const data = res.data.data
          const vendor = []
          const taxRate = []
          data.vendor.map(items => {
            vendor.push(items.bpName)
          })
          if (data.wTaxRate.length <= 0) {
            taxRate.push('X1 (None)')
          } else {
            data.wTaxRate.map(items => {
              taxRate.push(`${items.wTaxCode} ${items.wTaxDisplayName}`)
            })
          }

          const vatType = []
          data.vatType.map(items => {
            vatType.push(items === 'IVAT-S' ? 'Services IVAT-S' : items === 'IVAT-G' ? 'Goods IVAT-G' : 'None IVAT-X1')
          })
          setSuggestionsVendors(vendor)
        })
        _params.search = data.project ? data.project.projectName : ''
        ProjectsServices.getMany(_params).then(res => {
          const data = res.data.data
          const newData = []
          data.map(items => {
            newData.push(items.projectName)
          })
          setSuggestionsProject(newData)
        })
        setSelectedDate(data.dueDate)
        let requestingGrossPrice = 0.0
        let requestingAmount = 0.0
        for (let obj of projectClass) {
          requestingGrossPrice =
            parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice)
          requestingAmount =
            parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount)
        }
        setTimeout(function () {
          const newData = {
            _id: data._id,
            status: data.status,
            dueDate: data.dueDate,
            vendor: data.vendor ? data.vendor.bpName : '',
            crfNumber: data.crfNo,
            department: data.department ? data.department.centerName : '',
            releasingCenter: data.releasingCenter,
            project: data.project ? data.project.projectName : '',
            requestType: data.requestType,
            rejectionMessage: data.rejectionMessage,
            accountingApprover: data.accountingApprover,
            departmentApprover: data.departmentApprover,
            particulars: data.particulars,
            amount: data.amount,
            status: data.status,
            subProject: data.subProject,
            selectedFile: !data.supportingDocuments ? '' : data.supportingDocuments,
            projectClass: projectClass,
            requestingGrossPrice: requestingGrossPrice.toFixed(2),
            requestingAmount: requestingAmount.toFixed(2),
          }
          if (data.accountingApprover) newData.accountingApprover = data.accountingApprover
          if (data.departmentApprover) newData.departmentApprover = data.departmentApprover
          setValue(newData)
        }, 10)
      })
    }
  }, [id])

  // React.useEffect(() => {
  //   if (new Date(value.dueDate) < new Date()) alert('Due date must be date today or above!')
  // }, [value.dueDate])

  React.useEffect(() => {
    AuthServices.getUser().then(async res => {
      const dataFetched = res.data.data
      const departments = dataFetched.departments
      const depts = []
      departments.map(items => {
        depts.push(items.centerName)
      })
      setSuggestionsRequestingDepartment(depts)
    })
  }, [])

  React.useEffect(() => {
    setValue({
      ...value,
      dueDate: selectedDate
    })
  }, [selectedDate])
  const [errors, setErrors] = React.useState({
    firstPage: []
  })
  const [allowedFields, setAllowedFields] = React.useState({})

  const allowFields = () => {
    setAllowedFields(_allowedFieldsFirstPage)
  }

  const handleOnchange = (e, name) => {
    const val = e.target.value
    let projectClass = [...value.projectClass]
    setValue({
      ...value,
      projectClass: projectClass,
      [name]: val
    })
  }

  setTimeout(() => {
    allowFields()
  }, 10)

  const getValidator = value => {
    let error = null
    error = CreateNonPOItemsFirstPageValidator({
      dueDate: String(value.dueDate),
      vendor: value.vendor,
      amount: value.amount,
      department: value.department,
      particulars: value.particulars,
      project: value.project,
      releasingCenter: value.releasingCenter,
      selectedFile: value.selectedFile
    }).error
    if (error) {
      error = { ...error }
      console.group('Base Error')
        
      console.groupEnd()
      setErrors(state => ({ firstPage: state.firstPage, ...error }))
      return !!error
    }
  }

  const doValidateAll = data => {
    const firstPage = getValidator(data)
    setErrors(state => ({ ...state, firstPage }))
    return !!firstPage
  }

  const handOnNext = () => {
    setNext(true)
  }

  const onSubmitFunction = async () => {
    const data = {}
    for (let f in allowedFields) data[f] = value[f]
    const hasError = doValidateAll(data)
    if (hasError) {
      return
    }

    const filename = value.selectedFile.split('.')
    if (filename[filename.length - 1] !== 'pdf') {
      alert('Wrong File Extension!')
      return
    }

    let newDate = new Date()
    newDate.setDate(newDate.getDate() - 1)
    if (new Date(value.dueDate) >= newDate) {
      //
    } else {
      alert('Due date must be date today or above!')
      return
    }

    if (value.status === 'Returned') {
      await handleOnSubmitReturnedTransaction('For Approval')
    } else if (value.status === 'Draft') {
      handleOnResubmitDraft()
    } else {
      await handleOnSubmitTransaction('For Approval')
    }
  }
  const onSaveFunction = async () => {
    // const data = {}
    // for (let f in allowedFields) data[f] = value[f]
    // const hasError = doValidateAll(data)
    // if (hasError) {
    //   return
    // }
    let newDate = new Date()
    newDate.setDate(newDate.getDate() - 1)
    if (new Date(value.dueDate) >= newDate) {
      //
    } else {
      alert('Due date must be date today or above!')
      return
    }
    const filename = value.selectedFile.split('.')
    if (value.selectedFile !== '') {
      if (filename[filename.length - 1] !== 'pdf') {
        alert('Wrong File Extension!')
        return
      }
    }

    if (id === 'new-transaction') {
      await handleOnSubmitDraft('Draft')
    } else {
      handleOnSubmitOnSave()
    }
  }


  const handleOnResubmitDraft = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      amount: value.amount,
      _id: value._id,
      CAStatus: 'open',
      crfNumber: value.crfNumber,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Cash Advance',
      originalstatus: 'Draft',
      status: 'For Approval'
    }
    if (value.departmentApprover) data.departmentApprover = value.departmentApprover
    if (value.accountingApprover) data.accountingApprover = value.accountingApprover
    if (!value.file) data.selectedFile = value.selectedFile
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.resubmit(form, id).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }


  const handleOnSubmitReturnedTransaction = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      amount: value.amount,
      _id: value._id,
      CAStatus: 'open',
      crfNumber: value.crfNumber,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Cash Advance',
      originalstatus: value.status,
      status: value.status
    }
    if (value.departmentApprover) data.departmentApprover = value.departmentApprover
    if (value.accountingApprover) data.accountingApprover = value.accountingApprover
    if (!value.file) data.selectedFile = value.selectedFile
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.resubmit(form, id).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  const handleOnSubmitDraftTransaction = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      amount: value.amount,
      CAStatus: 'open',
      project: value.project,
      projectClasses: value.projectClass,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      requestType: 'Cash Advance',
      status: status
    }
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.submitDraft(form, id).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  const handleOnSubmitTransaction = (status) => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      project: value.project,
      amount: value.amount,
      CAStatus: 'open',
      projectClasses: value.projectClass,
      crfNumber: value.crfNumber,
      selectedFile: value.selectedFile,
      _id: value._id ? value._id : id,
      releasingCenter: value.releasingCenter,
      subProject: value.subProject,
      particulars: value.particulars,
      originalStatus: value.status,
      requestType: 'Cash Advance',
      status: 'For Approval'
    }
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.submit(form).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CheckRequest/${data._id}`)
    })
  }

  const handleOnSubmitDraft = () => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      amount: value.amount,
      project: value.project,
      projectClasses: value.projectClass,
      selectedFile: value.selectedFile,
      releasingCenter: value.releasingCenter,
      particulars: value.particulars,
      requestType: 'Cash Advance',
      status: 'Draft'
    }

    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.storeDraft(form).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      history.push(`/CashAdvance/${data._id}`)
    })
  }

  const handleOnSubmitOnSave = () => {
    setSubmitDisable(false)
    setLoading(true)
    let form = new FormData()
    const data = {
      dueDate: value.dueDate,
      department: value.department,
      vendor: value.vendor,
      amount: value.amount,
      _id: value._id,
      project: value.project,
      crfNumber: value.crfNumber,
      projectClasses: value.projectClass,
      selectedFile: value.selectedFile,
      releasingCenter: value.releasingCenter,
      particulars: value.particulars,
      requestType: 'Cash Advance',
      status: value.status
    }
    if (!value.file) data.selectedFile = value.selectedFile
    if (value.status === 'Returned') data.rejectionMessage = value.rejectionMessage
    form.set('data', JSON.stringify(data))
    form.append('supportingDocuments', value.file)
    TransactionServices.save(form).then(response => {
      const data = response.data.data
      if (data) setLoading(false)
      if (value.status === 'Draft') {
        history.push(`/CashAdvance/${data._id}`)
      } else {
        history.push(`/CheckRequest/${data._id}`)
      }
    })
  }

  React.useEffect(() => {
    if (value.selectedFile !== '') {
      const filename = value.selectedFile.split('.')
      if (filename[filename.length - 1] !== 'pdf') {
        setFileError('wrong')
        setButtonColor('red')
        setDisabled(true)
      } else {
        setButtonColor('green')
        setFileError('correct')
        setDisabled(false)
      }
    }
  }, [value.selectedFile])

  const handleOnChangeSelect = (e, name, isProjectClass, index) => {
    if (isProjectClass) {
      let projectClass = [...value.projectClass]
      projectClass[parseInt(index)][name] = name === 'grossPricePerItem' ? parseInt(e.target.value) : e.target.value
      setValue({ ...value, projectClass: projectClass })
    } else {
      setValue({
        ...value,
        [e.target.name]: e.target.value
      })
    }

  }

  return (
    <React.Fragment>
      <div className={classes.main_root}>
        <div id='sidePanel' className={classes.side_panel}>
          <SideNav
          />
        </div>
        <Box className={classes.root}>
          {next ? (
            <div className={classes['back-button-container']}>
              <Fab className={classes.button} onClick={() => setNext(false)}>
                <ArrowBackIosRounded className={classes.icon} />
              </Fab>
            </div>
          ) :
            ('')}
          <Box className={classes.header}>
            <Typography className={classes['header-label']}>{value.status === 'Draft' ? 'Cash Advances (Draft)' : 'Cash Advances'}</Typography>
            {/* <Typography className={classes['header-label-crf']}>({crfNumber})</Typography> */}
          </Box>
          <Divider className={classes.divider} />
          <Box className={classes.body}>
            <Paper className={classes.paper}>
              <Grid constainer spacing={1} className={classes['paper-body']}>
                {value.status === 'Returned' || value.status === 'Rejected' ? (
                  <Grid item xs={12} sm={12}>
                    <Paper className={classes.return_message}>
                      <Typography className={classes.header}>Remarks:</Typography>
                      <Typography className={classes.value}>{value.rejectionMessage.message}</Typography>
                    </Paper>
                  </Grid>
                ) : ('')}
                <Grid container item xs={12} alignItems='flex-end' justify='flex-end'>
                  <Button className={classes['save-button']} onClick={() => { onSaveFunction() }}>Save</Button>
                  <Button className={classes['header-cancel']}>
                    <Link to='/RequestSelection' style={{ textDecoration: 'none', color: 'white' }}>
                      Cancel
                    </Link>
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <CreateCashAdvances1stPage
                    classes={classes}
                    setSuggestionsVendors={setSuggestionsVendors}
                    setSuggestionsProject={setSuggestionsProject}
                    setSuggestionsRequestingDepartment={setSuggestionsRequestingDepartment}
                    params={params}
                    status={status}
                    type={type}
                    setDisabled={setDisabled}
                    setValue={setValue}
                    setFileError={setFileError}
                    fileError={fileError}
                    handleOnChangeSelect={handleOnChangeSelect}
                    onChangeAutoComplete={onChangeAutoComplete}
                    onClickAutoComplete={onClickAutoComplete}
                    setSuggestionsReleasingCenter={setSuggestionsReleasingCenter}
                    suggestionReleasingCenter={suggestionReleasingCenter}
                    value={value}
                    selectedDate={selectedDate}
                    setButtonColor={setButtonColor}
                    buttonColor={buttonColor}
                    setSelectedDate={setSelectedDate}
                    suggestionsVendor={suggestionsVendor}
                    suggestionsRequestingDepartment={suggestionsRequestingDepartment}
                    suggestionsProjects={suggestionsProjects}
                    handleOnchange={handleOnchange}
                    setSelectedFile={setSelectedFile}
                    selectedFile={selectedFile}
                    errors={errors}
                  />
                </Grid>
                <Grid container item xs={12} alignItems='flex-end' justify='flex-end'>
                  <Box>
                    <Button
                      className={classes['footer-next']}
                      // disabled={disabled}
                      onClick={() => { setSubmitDisable(true) }}
                    >Submit</Button>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Box>
          <Backdrop className={classes2.backdrop} open={loading}>
            <CircularProgress className={classes2.circular} thickness={10} />
            <Typography className={classes2.label}>Loading....</Typography>
          </Backdrop>
        </Box>
        {openDialog && (
          <CreationValidator
            openDialog={openDialog}
            title={'Creation Error'}
            close={() => { setOpenDialog(false) }}
            rawData={errorCollection}
            setLoading={setLoading}
          />
        )}
        {submitDisable && (
          <SubmissionValidator
            openDialog={submitDisable}
            title={'Create Transaction'}
            handeSave={() => { status === 'Draft' ? handleOnSubmitDraftTransaction('For Approval') : status === 'Returned' ? handleOnSubmitReturnedTransaction('For Approval') : onSubmitFunction() }}
            close={() => { setSubmitDisable(false) }}
          // rawData={errorCollection}
          />
        )}
      </div>
    </React.Fragment>
  )
}
